import { useState } from 'react';
import Button from '../../../../components/Button';
import Input from '../../../../components/Input';
import styles from './style.module.scss';
import { useDispatch, useSelector } from '../../../../store/store';
import { useNavigate } from 'react-router-dom';
import { resetPasswordThunk } from '../../../../store/forgetPassword/thunks';
import { selectFetchStatus } from '../../../../store/forgetPassword/selectors';
import { setForgetPasswordUsername } from '../../../../store/forgetPassword/slice';
import { TypographyLogo } from '../../../../assets/icons';
import { validateEmail } from '../../../../utils/generalHelpers';

function Username() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const fetchStatus = useSelector(selectFetchStatus);

    const next = () => {
        if (!validateEmail(email)) {
            setError('Email address is invalid.');
            return;
        }
        dispatch(setForgetPasswordUsername(email));
        dispatch(resetPasswordThunk(email));
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.head}>
                <TypographyLogo width={280} height={70} />
                <span className={styles.head_devider} />
                <span className={styles.head_title}>Forgot password</span>
            </div>
            <span className={styles.description}>
                Enter your verified email to receive a verification code.
            </span>
            <Input
                type='text'
                label='Email'
                value={email}
                error={error}
                onChange={setEmail}
            />
            <div className={styles.actions}>
                <Button
                    text='Back'
                    type='Outline-Dark'
                    className={styles.actions_btn}
                    disabled={fetchStatus === 'Pending'}
                    onClick={() => navigate('/signin')}
                />
                <Button
                    onClick={next}
                    text='Continue'
                    className={styles.actions_btn}
                    loading={fetchStatus === 'Pending'}
                />
            </div>
        </div>
    )
}

export default Username;
